import { render } from "./ActionWaitingTime.vue?vue&type=template&id=8e1272e0&ts=true"
import script from "./ActionWaitingTime.ts?vue&type=script&lang=ts"
export * from "./ActionWaitingTime.ts?vue&type=script&lang=ts"

import "./ActionWaitingTime.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__